import React from 'react'
import { Box, BoxProps } from '@clear/design-system'
import useEnrollmentApi from '@hooks/useEnrollmentApi'
import { useSessionTimer } from '@hooks/useSessionTimer'

type PageContentProps = BoxProps
const PageContent: React.FC<PageContentProps> = ({
  width = '48rem',
  ...props
}) => {
  const { clearState } = useEnrollmentApi()
  useSessionTimer(clearState)

  return (
    <Box>
      <Box
        px={3}
        width={['95%', width]}
        mx="auto"
        mt={[6, 7]}
        mb={6}
        {...props}
      />
    </Box>
  )
}

export default PageContent
